var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-items-like",on:{"click":_vm.clicked}},[_c('BaseIcon',{staticClass:"cursor-pointer",attrs:{"name":_vm.name,"color":_vm.color,"size":"sm-md"},on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }